"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCountryByCountryAbbreviation = exports.filterCountryByCountryCode = void 0;
const filterCountryByCountryCode = (allCountries, phoneCode) => {
    return (allCountries &&
        allCountries.filter((c) => c.phone_code === phoneCode)[0]);
};
exports.filterCountryByCountryCode = filterCountryByCountryCode;
const getCountryByCountryAbbreviation = (countries, countryAbbreviation) => {
    return countries && countries.filter((c) => c.abbreviation === countryAbbreviation)[0];
};
exports.getCountryByCountryAbbreviation = getCountryByCountryAbbreviation;
